module finadai.directives {
  interface ICompareToScope extends ng.IScope {
    comparer: any;
  }

  export function compareToDirective(): ng.IDirective{
    return {
      require: 'ngModel',
      scope: {
        comparer: '=compareTo'
      },
      link: function (scope: ICompareToScope, element, atts, ngModel: any) {
        ngModel.$validators.compareTo = function (modelValue) {
          return modelValue == scope.comparer;
        }
        scope.$watch("comparer", function() {
          ngModel.$validate();
        });
      }
    };
  }
}

